import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../hooks/redux';
import { fetchReputation } from '../store/slices/reputationSlice';
import { fetchLoyalty } from '../store/slices/loyaltySlice';
import { fetchProjects } from '../store/slices/projectsSlice';
import { fetchKYCStatus } from '../store/slices/kycSlice';
import ImpactDashboard from '../components/Dashboard/ImpactDashboard';
import ProjectGrid from '../components/Projects/ProjectGrid';
import KYCNotification from '../components/KYC/KYCNotification';

const DashboardPage = () => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const { items } = useAppSelector((state) => state.projects);

  useEffect(() => {
    dispatch(fetchReputation());
    dispatch(fetchLoyalty());
    dispatch(fetchKYCStatus());
    // Fetch user's projects
    dispatch(fetchProjects({ ownerId: user?.id }));
  }, [dispatch, user?.id]);

  // Get user's projects
  const myProjects = Object.values(items).filter(
    (project) => project.ownerId?._id === user?.id
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Dashboard</h1>
      
      {/* KYC Notification */}
      <KYCNotification />
      
      <div className="mb-8">
        <ImpactDashboard />
      </div>

      <div className="mt-8">
        <h2 className="text-2xl font-semibold mb-4">My Projects</h2>
        {myProjects.length > 0 ? (
          <ProjectGrid projects={myProjects} />
        ) : (
          <p className="text-[var(--color-subtext-color)]">You haven't created any projects yet.</p>
        )}
      </div>
    </div>
  );
};

export default DashboardPage;

